// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TqGQ","left":"styles_left__TNpD5"};